import { call, put, takeLatest } from "redux-saga/effects";
import billerService from "../../../services/api.services/biller/billerService";
import { Biller } from "../billers/billerTypes";
import {
  startProcess,
  billerDetailsFailure,
  billerDetailsSuccess,
  fetchPlansSuccess,
  billFetchSuccess,
  billValidationSuccess,
  processFailure,
  billContextSaved,
} from "./billerDetailAction";
import { savePaymentCtx } from "../../../utils/paymentLocal/paymentLocal";
// import { createRefId } from "../../../utils/refId/refId";

// function toIsoOffset(d = new Date()) {
//   const pad = (n: number) => String(n).padStart(2, "0");
//   const tzMin = -d.getTimezoneOffset();
//   const sign = tzMin >= 0 ? "+" : "-";
//   const hh = pad(Math.floor(Math.abs(tzMin) / 60));
//   const mm = pad(Math.abs(tzMin) % 60);
//   return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}${sign}${hh}:${mm}`;
// }
function* handleStartProcess(action: ReturnType<typeof startProcess>): any {
  try {
    const { billerId, values } = action.payload;

    // 1) Get Biller details (service already maps envelope → Biller)
    const biller: Biller = yield call(billerService.getBillerDetails, billerId);

    // console.log("handleStartProcess_getBillerDetails_ biller", biller);

    if (!biller || !biller.billerId) {
      yield put(billerDetailsFailure("Invalid biller details response"));
      return;
    }

    yield put(billerDetailsSuccess(biller));
    // console.log("handleStartProcess_billerDetailsSuccess_biller", biller);

    // 2) Plan requirement
    if (biller?.planMdmRequirement === "MANDATORY") {
      const planRes: any = yield call(billerService.fetchPlans, {
        search: [biller.billerId],
      });

      // console.log("handleStartProcess_fetchPlans_ planRes", planRes);

      yield put(fetchPlansSuccess(planRes?.data));
    }

    // 3) Fetch requirement
    if (biller?.fetchRequirement === "MANDATORY") {
      // const refId = ensureRefIdForBiller(billerId);
      // const { refId, timeIST } = createRefId(billerId);

      // console.log("::::::::::", values);

      // const body: BillFetchRequestBody = {
      //   refId,
      //   agentId: values?.agentId ?? "IF31IF03INT524833871",
      //   billerId,
      //   customerMobileNumber: values?.customerMobileNumber ?? "7378926854",
      //   customerParams: {
      //     "Mobile Number": values?.customerMobileNumber ?? "7378926854",
      //     "Last 4 digit of primary credit card number": values.last4 ?? "1864",
      //   },
      //   customerDetails: {
      //     EMAIL: values?.email ?? "kabir.gangurde4@gmail.com",
      //   },
      //   deviceDetails: {
      //     MAC: String(values.deviceId || "54-E1-AD-27-FE-E3"),
      //     IP: String(values.ip || "192.168.1.6"),
      //   },
      //   timeStamp: timeIST,
      // };
      // yield put(
      //   billContextSaved({
      //     refId,
      //     billerId,
      //     approvalRefNum: "IF31IF03INT524833871",
      //     customerMobileNumber: values?.customerMobileNumber ?? "7378926854",
      //     customerParams: {
      //       "Mobile Number": values?.customerMobileNumber ?? "7378926854",
      //       "Last 4 digit of primary credit card number":
      //         values.last4 ?? "1864",
      //     },
      //   }),
      // );
      // savePaymentCtx({
      //   refId,
      //   billerId,
      //   customerMobileNumber: values?.customerMobileNumber ?? "7378926854",
      //   customerParams: {
      //     "Mobile Number": values?.customerMobileNumber ?? "7378926854",
      //     "Last 4 digit of primary credit card number": values.last4 ?? "1864",
      //   },
      // });

      // const fetchRes : { data: any } = yield call(

      const fetchRes: any = yield call(billerService.billFetch, values);
      // let res = fetchRes?.data;
      // console.log("ZZZZZzz", fetchRes);

      yield put(
        billContextSaved({
          refId: fetchRes?.refId,
          billerId,
          approvalRefNum: fetchRes?.approvalRefNum,
          customerMobileNumber: values?.customerMobileNumber ?? "7378926854",
          customerParams: values?.customerParams,
        }),
      );
      savePaymentCtx({
        refId: fetchRes?.refId,
        billerId,
        customerMobileNumber: values?.customerMobileNumber ?? "7378926854",
        customerParams: values?.customerParams,
      });

      // console.log("handleStartProcess_billFetch_ fetchRes", fetchRes, " --- ");

      yield put(billFetchSuccess(fetchRes));
    }

    // 4) Validation requirement
    if (
      biller.supportBillValidation === "MANDATORY" ||
      biller.supportBillValidation === "OPTIONAL"
    ) {
      const validateRes: any = yield call(billerService.billValidation, {
        billerId: biller.billerId,
        customerParams: values.customerParams,
      });

      // console.log("validateRes{{{ ", validateRes);
      if (
        validateRes?.status === "true" ||
        validateRes?.reason?.responseReason === "Successful"
      ) {
        // console.log("conditioncheck:: ", validateRes);

        yield put(
          billContextSaved({
            refId: validateRes?.refId,
            billerId,
            approvalRefNum: validateRes?.reason?.approvalRefNum,
            customerMobileNumber: values?.customerMobileNumber ?? "7378926854",
            customerParams: values?.customerParams,
          }),
        );
        savePaymentCtx({
          refId: validateRes?.refId,
          billerId,
          customerMobileNumber: values?.customerMobileNumber ?? "7378926854",
          customerParams: values?.customerParams,
        });

        yield put(billValidationSuccess(validateRes));
      }
      // yield put(billvalidationfailure(validateRes.data));
    }

    // // 5) Payment (always last)
    // const paymentRes: { data: PaymentRequestBody } = yield call(
    //   billerService.billPayment,
    //   { ...values }
    // );
    // console.log("handleStartProcess_billPayment_ paymentRes", paymentRes);
    // yield put(billPaymentSuccess(paymentRes.data));
  } catch (err: any) {
    // console.error("catch_err_handleStartProcess", err);
    yield put(processFailure(err?.message || "Bill process failed"));
  }
}

export default function* billerDetailSaga() {
  yield takeLatest(startProcess.type, handleStartProcess);
}

// import { call, put, takeLatest } from "redux-saga/effects";
// import billerService from "../../../services/api.services/biller/billerService";

// function* handleStartProcess(action: ReturnType<typeof startProcess>) : any {
//   try {
//     const { billerId, values } = action.payload;

//     console.log("handleStartProcess", { billerId, values });

//     // 1) Get Biller details
//     const res = yield call(billerService.getBillerDetails, billerId);
//     const biller = res;
//     console.log("res", res);
//     console.log("biller", biller);

//     // if (!biller || !biller.billerId) {
//     //     console.log(biller,"  " + biller?.billerId);

//     //   yield put(billerDetailsFailure("Invalid biller details response..."));
//     //   return;
//     // }

//     yield put(billerDetailsSuccess(biller));

//     // 2) Check planMdmRequirement
//     if (biller.planMdmRequirement === "MANDATORY") {
//       const planRes = yield call(billerService.fetchPlans, billerId, { ...values });
//       yield put(fetchPlansSuccess(planRes.data));
//     }

//     // 3) Check fetchRequirement
//     if (biller.fetchRequirement === "MANDATORY") {
//       const fetchRes = yield call(billerService.billFetch, billerId, { ...values });
//       yield put(billFetchSuccess(fetchRes.data));
//     }

//     // 4) Check supportBillValidation
//     if (biller.supportBillValidation === "MANDATORY") {
//       const validateRes = yield call(billerService.billValidation, billerId, { ...values });
//       yield put(billValidationSuccess(validateRes.data));
//     }

//     // 5) Finally billPayment
//     const paymentRes = yield call(billerService.billPayment, billerId, { ...values });
//     yield put(billPaymentSuccess(paymentRes.data));
//   } catch (err: any) {
//     yield put(processFailure(err.message || "Bill process failed"));
//   }
// }

// export default function* billerDetailSaga() {
//   yield takeLatest(startProcess.type, handleStartProcess);
// }
